<template>
  <v-main class="account-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="title">
        <span>{{ title }}</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-container fluid>
      <v-list>
        <v-list-item class="py-2" :href="DocLink.HOME" target="_blank">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">关于艺爪</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>{{ mdiChevronRight }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item class="py-2" :href="DocLink.CONTACT" target="_blank">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">帮助与反馈</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>{{ mdiChevronRight }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider light class="my-2"></v-divider>
        <v-list-item class="py-2" @click="onLogout">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">退出登录</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>{{ mdiChevronRight }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider light class="my-2"></v-divider>
      </v-list>
    </v-container>
  </v-main>
</template>

<script>
import { homeStore } from '@/store/home'
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { merchantStore } from '@/store/merchant'
import { mdiChevronRight } from '@mdi/js'
import { DocLink } from '@/plugins/doc'

export default {
  components: { AppbarBackIcon },
  data() {
    return {
      mdiChevronRight,
      DocLink,
    }
  },
  computed: {
    title() {
      return merchantStore.username
    },
  },
  async mounted() {
    await homeStore.doLoad()
  },
  methods: {
    async onLogout() {
      await merchantStore.doLogout()
    },
  },
}
</script>

<style lang="less" scoped>
.account-page {
  .title {
    font-weight: bold;
    margin: 0 auto;
    position: relative;
    left: -24px;
  }
}
</style>
